module.exports = __webpack_public_path__ + "img/ATT_FAQ01.c33322a3.jpg";